import { useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
// import AddResourceCharge from "../modals/AddResourceCharge";
import Table from "../reusable_components/Table";
import AddServiceList from "../modals/AddServiceList";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnGreen, btnRed, title, btnOneNoWidth } from "../utils/style";
import edit from '../assets/icons/edit.png'
import deleteIcon from '../assets/icons/delete.png'
import ConfirmationModal from "../reusable_components/ConfirmationModal";
import { convertMinToHour } from "../utils/dateTime";
import formatNumberToUs from "../custom_functions/formatNumberToUs";


function ServiceList() {
    const [showAddAndModifyService, setShowAddAndModifyService] = useState(false);
    const [serviceData, setServiceData] = useState(null)
    const [deleteId, setDeleteId] = useState(null)
    const [reloadTable, setReloadTable] = useState(false)

    async function deleteService() {
        try {
            const reqUrl = url + '/services/service_list/' + deleteId;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.delete(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 })
            console.log(data);
            setReloadTable(1 + Math.random())
        } catch (error) {
            toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 })
            console.log(error)
        }
        finally {
            setDeleteId(null)
        }
    }

    function toggleModify(data) {
        setServiceData(data);
        setShowAddAndModifyService(true)
    }

    const options = [
        {
            header: 'Service Name',
            key: 'name',
        },
        {
            header: 'Service Type',
            key: 'serviceType',
        },
        {
            header: 'Short Description',
            key: 'shortDescription',
        },
        {
            header: 'Estimated Time/Cost',
            render: (data) => { 
                if(data.costType === 'Hourly') {
                    return convertMinToHour(data.estimatedTime)
                } else {
                    return `$${formatNumberToUs(data.estimatedCost)}`
                }
            },
        },
        {
            header: 'Cost Type',
            key: 'costType',
        },
        {
            header: 'Bundled Item',
            render: (data) => {
                return (
                    data.service_bundles.length === 0 ? 'NO' : 'YES'
                )
            },
        },
        {
            header: 'Images',
            render: (data) => {
                let images = [];

                try {
                    images = JSON.parse(data.serviceImages);
                } catch (e) {
                    images = [];
                }

                if(images.length === 0) {
                    return 'No Image';
                }

                return images.length > 1 ? (
                    <div className="flex gap-2 overflow-x-auto max-w-[250px] border border-gray-300 p-2 rounded-md">
                        {images.map((img, ind) => (
                            <img
                                className="h-[40px] object-cover"
                                src={`${url}/images/${img}`}
                                key={ind}
                                alt="Service"
                            />
                        ))}
                    </div>
                ) : (
                    <img
                        src={`${url}/images/${images[0] || ''}`}
                        className="h-[40px] object-cover"
                        alt="Service"
                    />
                );
            }
        },
        {
            header: 'Action',
            render: (data) => {
                return (
                    <div className="">
                        <button
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => toggleModify(data)}
                        >
                            <img src={edit} height={15} width={15} />
                        </button>
                        <button
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => setDeleteId(data.id)}
                        >
                            <img src={deleteIcon} height={15} width={15} />
                        </button>
                    </div>
                )
            }
        }
    ]

    const excludeFilter = ['Short Description', 'Bundled Item', 'Images', 'Action', 'Estimated Time/Cost']

    return (
        <div className="p-4">
            {
                showAddAndModifyService && <AddServiceList serviceData={serviceData} reload={setReloadTable} setServiceData={setServiceData} setShowModal={setShowAddAndModifyService} />
            }
            {
                deleteId && <ConfirmationModal title={'Service'} setShowForm={setDeleteId} confirm={deleteService} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Service List</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Service`} clickHandler={() => setShowAddAndModifyService(!showAddAndModifyService)} />
                )}
            </div>

            <Table
                options={options}
                url={url + '/services/service_list'}
                pagination
                clickHandler={() => setShowAddAndModifyService(!showAddAndModifyService)}
                btnTitle={'Service'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default ServiceList;